import { render, staticRenderFns } from "./app_version.vue?vue&type=template&id=2a283a3a&scoped=true"
import script from "./app_version.vue?vue&type=script&lang=js"
export * from "./app_version.vue?vue&type=script&lang=js"
import style0 from "./app_version.vue?vue&type=style&index=0&id=2a283a3a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a283a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a283a3a')) {
      api.createRecord('2a283a3a', component.options)
    } else {
      api.reload('2a283a3a', component.options)
    }
    module.hot.accept("./app_version.vue?vue&type=template&id=2a283a3a&scoped=true", function () {
      api.rerender('2a283a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/neewerdownload/app_version.vue"
export default component.exports